/* ============================================================
   Toko — JS global du thème
   - Navigation mobile (burger)
   - Ajout au panier en ajax + mise à jour de la bulle panier
   La page produit (galerie, variantes, quantité) garde son JS
   dédié dans sections/main-product.liquid.
   ============================================================ */
(function () {
  'use strict';

  /* ---------- Navigation mobile ---------- */
  function initMobileNav() {
    var toggle = document.querySelector('[data-nav-toggle]');
    var nav = document.querySelector('[data-mobile-nav]');
    if (!toggle || !nav) return;

    toggle.addEventListener('click', function () {
      var open = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });

    // Referme le menu quand on clique un lien
    nav.addEventListener('click', function (e) {
      if (e.target.closest('a')) {
        nav.classList.remove('is-open');
        toggle.setAttribute('aria-expanded', 'false');
      }
    });
  }

  /* ---------- Bulle panier ---------- */
  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = count < 1;
    });
  }

  /* ---------- Petit toast de confirmation ---------- */
  function toast(message) {
    var el = document.createElement('div');
    el.className = 'toast';
    el.setAttribute('role', 'status');
    el.textContent = message;
    document.body.appendChild(el);
    requestAnimationFrame(function () { el.classList.add('is-visible'); });
    setTimeout(function () {
      el.classList.remove('is-visible');
      setTimeout(function () { el.remove(); }, 300);
    }, 2600);
  }

  /* ---------- Ajout au panier en ajax ---------- */
  function initAjaxCart() {
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form.matches('form[action$="/cart/add"]')) return;

      e.preventDefault();
      var btn = form.querySelector('[type="submit"]');
      var label = form.querySelector('[data-add-label]');
      var prevLabel = label ? label.textContent : '';
      if (btn) btn.disabled = true;
      if (label) label.textContent = 'Ajout…';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: new FormData(form)
      })
        .then(function (r) {
          if (!r.ok) return r.json().then(function (j) { throw j; });
          return r.json();
        })
        .then(function () {
          return fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
        })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          updateCartCount(cart.item_count);
          toast('Produit ajouté au panier ✓');
          if (label) label.textContent = prevLabel || 'Ajouter au panier';
          if (btn) btn.disabled = false;
        })
        .catch(function (err) {
          // En cas d'échec ajax, on retombe sur l'envoi classique du formulaire
          if (err && err.description) {
            toast(err.description);
            if (label) label.textContent = prevLabel;
            if (btn) btn.disabled = false;
          } else {
            form.submit();
          }
        });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initMobileNav();
    initAjaxCart();
  });
})();
